import { useMemo } from 'react';

import {
  flowFunctionsSelectors,
  flowStepsSelectors,
  flowsSelectors,
} from '@polyai/stream/store/reducers/flows';
import {
  isAdvancedStep,
  isFunctionStep,
} from '@polyai/stream/store/reducers/flows/types/steps';

import { useAppSelector } from 'hooks/reduxHooks';
import useProjectRoute from 'hooks/useProjectRoute';

const useFlowState = () => {
  const { accountId, projectId, flowId } = useProjectRoute<{
    flowId: string;
  }>();
  const flow = useAppSelector(state =>
    flowsSelectors.selectById(state.flows.flows, flowId),
  );
  const flowFunctions = useMemo(
    () =>
      flow?.transitionFunctions
        ? flowFunctionsSelectors
            .selectAll(flow?.transitionFunctions)
            .filter(func => !func.archived)
        : [],
    [flow],
  );

  const steps = useMemo(
    () => (flow?.steps ? flowStepsSelectors.selectAll(flow.steps) : []),
    [flow],
  );

  const advancedSteps = useMemo(() => steps.filter(isAdvancedStep), [steps]);

  const functionSteps = useMemo(() => steps.filter(isFunctionStep), [steps]);

  return {
    accountId,
    projectId,
    flowId,
    flow,
    flowFunctions,
    steps,
    advancedSteps,
    functionSteps,
  };
};

export default useFlowState;
